<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/dashboard" name="Home" icon="ti-panel" />
        <sidebar-link to="/stockout" name="Stockout" icon="ti-package" />
        <sidebar-link
          to="/purchase_order"
          name="Purchase Order"
          icon="ti-credit-card"
        />
        <sidebar-link
          to="/delivery_order"
          name="Delivery Order"
          icon="ti-export"
        />
        <sidebar-link
          to="/monthly_forecast"
          name="Monthly Forecast"
          icon="ti-menu"
        />
        <sidebar-link
          to="/user_management"
          name="User Management"
          icon="ti-user"
        />
        <sidebar-link to="/outlet" name="Outlet" icon="ti-home" />
        <sidebar-link to="/product" name="Product" icon="ti-pencil-alt2" />
        <sidebar-link to="/home_dealer_admin" name="Home Dealer" icon="ti-user" />
        <sidebar-link to="/audit_trail" name="Audit Trail" icon="ti-harddrives" />
        <sidebar-link to="/logout" name="Logout" icon="ti-shift-left" />
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"></dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
// import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent
    // MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    onClickPush() {
      alert("Test");
      this.$router.push({ path: `/setting` });
    }
  }
};
</script>
